import React, { useRef, useState } from "react";
import { imageUrl } from "@/lib/api";

/**
 * Renders a poster image; on hover starts an inline muted preview of the video.
 * Video files must be short (<= 15s). Falls back gracefully if missing.
 */
export function HoverVideoPreview({ videoUrl, poster, alt = "", className = "", roundedCls = "rounded-2xl" }) {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const src = videoUrl ? imageUrl(videoUrl) : "";

  const onEnter = () => {
    if (!videoRef.current) return;
    setPlaying(true);
    try {
      videoRef.current.currentTime = 0;
      const p = videoRef.current.play();
      if (p && p.catch) p.catch(() => {});
    } catch (_e) { /* ignore */ }
  };
  const onLeave = () => {
    if (!videoRef.current) return;
    try {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    } catch (_e) { /* ignore */ }
    setPlaying(false);
  };

  return (
    <div
      onMouseEnter={src ? onEnter : undefined}
      onMouseLeave={src ? onLeave : undefined}
      onTouchStart={src ? onEnter : undefined}
      onTouchEnd={src ? onLeave : undefined}
      className={`relative overflow-hidden ${roundedCls} ${className}`}
    >
      {poster && (
        <img
          src={imageUrl(poster)}
          alt={alt}
          className={`w-full h-full object-cover transition-opacity duration-300 ${playing ? "opacity-0" : "opacity-100"}`}
          loading="lazy"
        />
      )}
      {src && (
        <video
          ref={videoRef}
          src={src}
          muted
          loop
          playsInline
          preload="metadata"
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${playing ? "opacity-100" : "opacity-0"}`}
        />
      )}
      {src && (
        <span className="absolute bottom-2 left-2 bg-hyd-bg/85 backdrop-blur text-hyd-gold text-[9px] font-bold uppercase tracking-widest px-1.5 py-0.5 rounded-full">
          ▸ Preview
        </span>
      )}
    </div>
  );
}
